
import { defineComponent, onMounted } from 'vue';
// eslint-disable-next-line import/no-cycle
import MonitoringService from '@/services/MonitoringService';

export default defineComponent({
  setup() {
    async function pingBackEnd() {
      try {
        const request = await MonitoringService.pingBackEnd();

        if (request.status === 200) {
          if (window.location.href !== 'http://localhost:8080/no-status') {
            window.location.replace(process.env.VUE_APP_DOMAIN_URL as string);
          } else {
            window.location.replace('http://localhost:8080/');
          }
          return;
        }
        setTimeout(() => pingBackEnd(), 3000);
      } catch (e) {
        setTimeout(() => pingBackEnd(), 3000);
      }
    }

    onMounted(() => {
      pingBackEnd();
    });

    return {
    };
  },
});
